import SupportIcon from '@mui/icons-material/Support';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import EventNoteIcon from '@mui/icons-material/EventNote';

export const BASE_URL = 'https://zaminhost.com';

export const lastNewsList = [
    'خطای 401 چیست؟ چرا این خطا به وجود می آید و چگونه آن را رفع کنیم؟',
    'خطای 400 چیست؟ چرا این خطا به وجود می آید و چگونه آن را رفع کنیم؟',
    'کنترل پنل پلسک (Plesk) چیست؟ مزایا و معایب استفاده از آن کدامند؟',
    'کنترل پنل دایرکت ادمین (DirectAdmin) چیست؟ مزایا و معایب استفاده از آن کدامند؟'
];
export const factorColumns = [
    {id: 'id', label: 'ردیف', width: 50, align: 'right'},
    {id: 'invoice_no', label: 'شماره فاکتور', minWidth: 100, align: 'center'},
    // {
    //   id: 'factor_no',
    //   label: 'شماره رسمی',
    //   minWidth: 100,
    //   align: 'center',
    //   format: (value) => value.toLocaleString('en-US')
    // },
    {
        id: 'service_name',
        label: 'سرویس',
        minWidth: 100,
        align: 'right',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'invoice_period',
        label: 'بازه زمانی',
        minWidth: 100,
        align: 'right',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'invoice_date',
        label: 'تاریخ فاکتور',
        minWidth: 100,
        align: 'center',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'total_payment',
        label: 'مبلغ پرداختی',
        minWidth: 100,
        align: 'center',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'detail',
        label: 'جزییات',
        minWidth: 100,
        align: 'center',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'status',
        label: 'وضعیت',
        width: 70,
        align: 'left',
        format: (value) => value.toLocaleString('en-US')
    },
    // {
    //   id: 'type',
    //   label: 'نوع فاکتور',
    //   minWidth: 100,
    //   align: 'center',
    //   format: (value) => value.toLocaleString('en-US')
    // },
    // {
    //   id: 'ref_id',
    //   label: 'کد پیگیری',
    //   minWidth: 100,
    //   align: 'center',
    //   format: (value) => value.toLocaleString('en-US')
    // }
];
export const factorDetailRow = [
    {
        factorId: 1,
        controlPanel: 500000,
        OP: 500000,
        IPAddress: 200000,
        dataCenter: 1000000,
        Country: 500000
    },
    {
        factorId: 2,
        controlPanel: 500000,
        OP: 500000,
        IPAddress: 200000,
        dataCenter: 1000000,
        Country: 500000
    },
    {
        factorId: 3,
        controlPanel: 500000,
        OP: 500000,
        IPAddress: 200000,
        dataCenter: 1000000,
        Country: 500000
    },
    {
        factorId: 4,
        controlPanel: 500000,
        OP: 500000,
        IPAddress: 200000,
        dataCenter: 1000000,
        Country: 500000
    },
    {
        factorId: 5,
        controlPanel: 500000,
        OP: 500000,
        IPAddress: 200000,
        dataCenter: 1000000,
        Country: 500000
    },
    {
        factorId: 6,
        controlPanel: 500000,
        OP: 500000,
        IPAddress: 200000,
        dataCenter: 1000000,
        Country: 500000
    }
];
export const userInfo = [
    {info: 'صادق دهلوی', color: 'bg-success', badge: 'badge-light-success'},
    {
        info: 'شرکت خصوصی زام دیزاین',
        color: 'bg-danger',
        badge: 'badge-light-danger'
    },
    {info: '09153334546', color: 'bg-warning', badge: 'badge-light-warning'},
    {
        info: 'بلوار وکیل آباد، دانش آموز 19',
        color: 'bg-primary',
        badge: 'badge-light-primary'
    }
];
export const indexHeader = [
    {
        svg: <SupportIcon className={'text-white f-3'}/>,
        bg: 'bg-danger',
        title: 'تیکت ها',
        subTitle: '1'
    },
    {
        svg: <MiscellaneousServicesIcon className={'text-white f-3'}/>,
        bg: 'bg-primary',
        title: 'سرویس ها',
        subTitle: '5'
    },
    {
        svg: <EventNoteIcon className={'text-white f-3'}/>,
        bg: 'bg-success',
        title: 'فاکتورها',
        subTitle: '3'
    }
];
export const serviceColumns = [
    {id: 'ID', label: 'ردیف', minWidth: 50, align: 'right'},
    {id: 'id', label: 'شماره سرویس', minWidth: 100, align: 'right'},
    {id: 'product_name', label: 'محصول', minWidth: 100, align: 'right'},
    {
        id: 'label',
        label: 'عنوان',
        minWidth: 100,
        align: 'center',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'IP',
        label: 'IP',
        minWidth: 100,
        align: 'center',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'start_date',
        label: 'تاریخ شروع',
        minWidth: 100,
        align: 'center',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'expire_date',
        label: 'تاریخ سررسید',
        minWidth: 100,
        align: 'center',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'status',
        label: 'وضعیت',
        minWidth: 100,
        align: 'center',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'detail',
        label: 'جزییات',
        minWidth: 100,
        align: 'center',
        format: (value) => value.toLocaleString('en-US')
    }
];
export const serviceDetailRow = [
    {
        serviceId: 1,
        cpu: 11,
        ram: '16GB',
        dataCenter: 'انتخابی',
        hard: '100GB',
        traffic: '1GB',
        port: '1GB'
    },
    {
        serviceId: 2,
        cpu: 12,
        ram: '16GB',
        dataCenter: 'انتخابی',
        hard: '100GB',
        traffic: '1GB',
        port: '1GB'
    },
    {
        serviceId: 3,
        cpu: 13,
        ram: '16GB',
        dataCenter: 'انتخابی',
        hard: '100GB',
        traffic: '1GB',
        port: '1GB'
    },
    {
        serviceId: 4,
        cpu: 14,
        ram: '16GB',
        dataCenter: 'انتخابی',
        hard: '100GB',
        traffic: '1GB',
        port: '1GB'
    },
    {
        serviceId: 5,
        cpu: 15,
        ram: '16GB',
        dataCenter: 'انتخابی',
        hard: '100GB',
        traffic: '1GB',
        port: '1GB'
    },
    {
        serviceId: 6,
        cpu: 16,
        ram: '16GB',
        dataCenter: 'انتخابی',
        hard: '100GB',
        traffic: '1GB',
        port: '1GB'
    }
];
export const serviceDescriptionRow = [
    {
        serviceId: 1,
        description: 'ویژگی سرویس 11',
        techniqueDesc: 'ویژگی سرویس',
        techniqueQuantity: 11
    },
    {
        serviceId: 2,
        description: 'ویژگی سرویس 12',
        techniqueDesc: 'ویژگی سرویس',
        techniqueQuantity: 12
    },
    {
        serviceId: 3,
        description: 'ویژگی سرویس 13',
        techniqueDesc: 'ویژگی سرویس',
        techniqueQuantity: 13
    },
    {
        serviceId: 4,
        description: 'ویژگی سرویس 14',
        techniqueDesc: 'ویژگی سرویس',
        techniqueQuantity: 14
    },
    {
        serviceId: 5,
        description: 'ویژگی سرویس 15',
        techniqueDesc: 'ویژگی سرویس',
        techniqueQuantity: 15
    },
    {
        serviceId: 6,
        description: 'ویژگی سرویس 16',
        techniqueDesc: 'ویژگی سرویس',
        techniqueQuantity: 16
    }
];
export const ticketColumns = [
    // { id: 'ID', label: 'ردیف', minWidth: 50, align: 'right' },
    {
        id: 'id',
        label: 'شماره تیکت',
        minWidth: 100,
        align: 'center',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'title',
        label: 'عنوان',
        minWidth: 100,
        align: 'right'
    },
    {
        id: 'created_at',
        label: 'تاریخ',
        minWidth: 100,
        align: 'center',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'status',
        label: 'وضعیت',
        minWidth: 100,
        align: 'right',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'detail',
        label: 'جزییات',
        minWidth: 100,
        align: 'right',
        format: (value) => value.toLocaleString('en-US')
    }
];
export const ticketStatus = [
    // 0 index
    {
        title: 'منتظر پاسخ',
        badge: 'badge-light-warning'
    },
    // 1 index
    {
        title: 'پاسخ داده شده',
        badge: 'badge-light-success'
    },
    // 2 index
    {
        title: 'بسته',
        badge: 'badge-light-primary'
    }
];
export const factorStatus = [
    // 0 index
    {
        title: 'پرداخت نشده',
        badge: 'badge-light-warning'
    },
    // 1 index
    {
        title: 'پرداخت شده',
        badge: 'badge-light-success'
    },
    // 2 index
    {
        title: 'تحویل شده',
        badge: 'badge-light-success'
    },
    {
        title: 'لغو شده',
        badge: 'badge-light-danger'
    }
];
export const ticketRow = [
    {
        id: 1,
        userName: '',
        title: 'تیکت1',
        date: '1401/02/23',
        ticketCode: '#230',
        status: 'منتظر پاسخ',
        color: 'badge-light-warning'
    },
    {
        id: 2,
        userName: '',
        title: 'تیکت2',
        date: '1401/02/23',
        ticketCode: '#231',
        status: ' پاسخ داده شده',
        color: 'badge-light-success'
    },
    {
        id: 3,
        userName: '',
        title: 'تیکت3',
        date: '1401/02/23',
        ticketCode: '#233',
        status: 'بسته',
        color: 'badge-light-danger'
    },
    {
        id: 4,
        userName: '',
        title: 'تیکت4',
        date: '1401/02/23',
        ticketCode: '#234',
        status: 'منتظر پاسخ',
        color: 'badge-light-warning'
    },
    {
        id: 5,
        userName: '',
        title: 'تیکت5',
        date: '1401/02/23',
        ticketCode: '#235',
        status: ' پاسخ داده شده',
        color: 'badge-light-primary'
    },
    {
        id: 6,
        userName: '',
        title: 'تیکت6',
        date: '1401/02/23',
        ticketCode: '#236',
        status: 'بسته',
        color: 'badge-light-success'
    }
];
export const ticketDetailRow = [
    {
        ticketId: 1,
        user: 'user',
        text:
            'لورم ایپسوم متن ساختگی با تولید ' +
            'سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، ' +
            'چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم ' +
            'است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع' +
            ' با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت',
        date: '1401/01/15'
    },
    {
        ticketId: 1,
        user: 'admin',
        text:
            'لورم ایپسوم متن ساختگی با تولید ' +
            'سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، ' +
            'چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم ' +
            'است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع' +
            ' با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت',
        date: '1401/01/15'
    },
    {
        ticketId: 1,
        user: 'user',
        text:
            'لورم ایپسوم متن ساختگی با تولید ' +
            'سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، ' +
            'چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم ' +
            'است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع' +
            ' با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت',
        date: '1401/02/23'
    },
    {
        ticketId: 1,
        user: 'admin',
        text:
            'لورم ایپسوم متن ساختگی با تولید ' +
            'سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، ' +
            'چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم ' +
            'است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع' +
            ' با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت',
        date: '1401/02/23'
    },
    {
        ticketId: 2,
        user: 'user',
        text:
            'لورم ایپسوم متن ساختگی با تولید ' +
            'سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، ' +
            'چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم ' +
            'است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع' +
            ' با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت',
        date: '1401/02/23'
    },
    {
        ticketId: 2,
        user: 'admin',
        text:
            'لورم ایپسوم متن ساختگی با تولید ' +
            'سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، ' +
            'چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم ' +
            'است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع' +
            ' با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت',
        date: '1401/02/23'
    },
    {
        ticketId: 2,
        user: 'user',
        text:
            'لورم ایپسوم متن ساختگی با تولید ' +
            'سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، ' +
            'چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم ' +
            'است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع' +
            ' با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت',
        date: '1401/02/23'
    },
    {
        ticketId: 2,
        user: 'admin',
        text:
            'لورم ایپسوم متن ساختگی با تولید ' +
            'سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، ' +
            'چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم ' +
            'است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع' +
            ' با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت',
        date: '1401/02/23'
    },
    {
        ticketId: 2,
        user: 'user',
        text:
            'لورم ایپسوم متن ساختگی با تولید ' +
            'سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، ' +
            'چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم ' +
            'است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع' +
            ' با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت',
        date: '1401/02/23'
    }
];
export const iranServerColumns = [
    {id: 'id', label: 'ردیف', align: 'right'},
    {id: 'title', label: 'نام سرور', align: 'center'},
    {
        id: 'number_processors',
        label: 'تعداد پردازنده',
        align: 'center',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'ram',
        label: 'رم',
        align: 'center',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'data_center',
        label: 'دیتاسنتر',
        align: 'center',
        class: 'd-none d-md-table-cell',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'hard_space',
        label: 'فضای هارد',
        align: 'center',
        class: 'd-none d-lg-table-cell',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'traffic',
        label: 'ترافیک',
        align: 'center',
        class: 'd-none d-xl-table-cell',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'connection_port',
        label: 'پورت اتصال',
        align: 'center',
        class: 'd-none d-xl-table-cell',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'price',
        label: 'هزینه ماهانه',
        align: 'center',
        class: 'd-none d-md-table-cell',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'order',
        label: 'سفارش',
        align: 'right',
        format: (value) => value.toLocaleString('en-US')
    }
];
export const iranServerRow = [
    {
        productId: 1,
        server: 'VDS-IR2',
        cpu: 'Core 2',
        ram: '4 گیگابایت',
        dataCenter: 'انتخابی',
        hard: '75 گیگابایت NVMe',
        traffic: 'نامحدود',
        port: '1 گیگابیت',
        price: '450000'
    },
    {
        productId: 2,
        server: 'VDS-IR3',
        cpu: 'Core 3',
        ram: '16 گیگابایت',
        dataCenter: 'انتخابی',
        hard: '250 گیگابایت NVMe',
        traffic: 'نامحدود',
        port: '1 گیگابیت',
        price: '450000'
    },
    {
        productId: 3,
        server: 'VDS-IR1',
        cpu: 'Core 2',
        ram: '32 گیگابایت',
        dataCenter: 'انتخابی',
        hard: '75 گیگابایت NVMe',
        traffic: 'نامحدود',
        port: '1 گیگابیت',
        price: '450000'
    },
    {
        productId: 4,
        server: 'VDS-IR4',
        cpu: 'Core 2',
        ram: '8 گیگابایت',
        dataCenter: 'انتخابی',
        hard: '50 گیگابایت NVMe',
        traffic: 'نامحدود',
        port: '1 گیگابیت',
        price: '450000'
    },
    {
        productId: 5,
        server: 'VDS-IR1',
        cpu: 'Core 2',
        ram: '16 گیگابایت',
        dataCenter: 'انتخابی',
        hard: '150 گیگابایت NVMe',
        traffic: 'نامحدود',
        port: '1 گیگابیت',
        price: '450000'
    },
    {
        productId: 6,
        server: 'VDS-IR2',
        cpu: 'Core 2',
        ram: '8 گیگابایت',
        dataCenter: 'انتخابی',
        hard: '100 گیگابایت NVMe',
        traffic: 'نامحدود',
        port: '1 گیگابیت',
        price: '450000'
    }
];
export const europeServerColumns = [
    {id: 'id', label: 'ردیف', minWidth: 50, align: 'right'},
    {id: 'title', label: 'نام سرور', minWidth: 100, align: 'center'},
    {
        id: 'number_processors',
        label: 'تعداد پردازنده',
        minWidth: 100,
        align: 'center',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'ram',
        label: 'رم',
        minWidth: 100,
        align: 'center',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'data_center',
        label: 'دیتاسنتر',
        minWidth: 100,
        align: 'center',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'hard_space',
        label: 'فضای هارد',
        minWidth: 100,
        align: 'center',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'traffic',
        label: 'ترافیک',
        minWidth: 100,
        align: 'center',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'connection_port',
        label: 'پورت اتصال',
        minWidth: 100,
        align: 'center',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'price',
        label: 'هزینه ماهانه',
        minWidth: 100,
        align: 'center',
        format: (value) => value.toLocaleString('en-US')
    },
    {
        id: 'order',
        label: 'سفارش',
        minWidth: 100,
        align: 'right',
        format: (value) => value.toLocaleString('en-US')
    }
];
export const europeServerRow = [
    {
        productId: 1,
        server: 'VDS-IR2',
        cpu: 'Core 2',
        ram: '4 گیگابایت',
        dataCenter: 'بر اساس کشور',
        hard: '75 گیگابایت NVMe',
        traffic: 'نامحدود',
        port: '1 گیگابیت',
        price: '450000'
    },
    {
        productId: 2,
        server: 'VDS-IR3',
        cpu: 'Core 3',
        ram: '16 گیگابایت',
        dataCenter: 'بر اساس کشور',
        hard: '250 گیگابایت NVMe',
        traffic: 'نامحدود',
        port: '1 گیگابیت',
        price: '450000'
    },
    {
        productId: 3,
        server: 'VDS-IR1',
        cpu: 'Core 2',
        ram: '32 گیگابایت',
        dataCenter: 'بر اساس کشور',
        hard: '75 گیگابایت NVMe',
        traffic: 'نامحدود',
        port: '1 گیگابیت',
        price: '450000'
    },
    {
        productId: 4,
        server: 'VDS-IR4',
        cpu: 'Core 2',
        ram: '8 گیگابایت',
        dataCenter: 'بر اساس کشور',
        hard: '50 گیگابایت NVMe',
        traffic: 'نامحدود',
        port: '1 گیگابیت',
        price: '450000'
    },
    {
        productId: 5,
        server: 'VDS-IR1',
        cpu: 'Core 2',
        ram: '16 گیگابایت',
        dataCenter: 'بر اساس کشور',
        hard: '150 گیگابایت NVMe',
        traffic: 'نامحدود',
        port: '1 گیگابیت',
        price: '450000'
    },
    {
        productId: 6,
        server: 'VDS-IR2',
        cpu: 'Core 2',
        ram: '8 گیگابایت',
        dataCenter: 'بر اساس کشور',
        hard: '100 گیگابایت NVMe',
        traffic: 'نامحدود',
        port: '1 گیگابیت',
        price: '450000'
    }
];
export const serverOrderIcon = [
    {
        title: 'کنترل پنل',
        icon: 'bi-menu-button-wide f-2'
    },
    {
        title: 'سیستم عامل',
        icon: 'bi-window-stack f-1'
    },
    {
        title: 'IP Address',
        icon: 'bi-cpu f-1'
    },
    {
        title: 'دیتا سنتر',
        icon: 'bi-clipboard-data f-1'
    },
    {
        title: 'کشور',
        icon: 'bi-globe f-2'
    },
    {
        title: 'افزایش هارد',
        icon: 'bi-hdd-rack f-2'
    },
    {
        title: 'افزایش هارد Nvme',
        icon: 'bi-hdd-rack f-2'
    }
];
export const classIcon = (item) => {
    let res = '';
    switch (item) {
        case 'کنترل پنل':
            res = 'text-white bi bi-menu-button-wide f-2';
            break;
        case 'سیستم عامل':
            res = 'text-white bi bi-window-stack f-2';
            break;
        case 'IP Address':
            res = 'text-white bi bi-cpu f-22';
            break;
        case 'دیتا سنتر':
            res = 'text-white bi bi-clipboard-data f-2';
            break;
        case 'کشور':
            res = 'text-white bi bi-globe f-2';
            break;
        case 'افزایش هارد':
            res = 'text-white bi bi-hdd-rack f-2';
            break;
        case 'افزایش هارد Nvme':
            res = 'text-white bi bi-hdd-rack f-2';
            break;
        default:
            res = 'text-white bi bi-menu-button-wide f-2';
    }
    return res;
};

export const accessGroupColumns = [
    {id: 'id', label: 'ردیف', width: 50, align: 'right'},
    {id: 'group_name', label: 'نام', minWidth: 100, align: 'center'},
    {
        id: 'service_access',
        label: 'دسترسی سرویس',
        minWidth: 100,
        align: 'right',
    },
    {
        id: 'finance_access',
        label: 'دسترسی مالی',
        minWidth: 100,
        align: 'right',
    },
    {
        id: 'support_access',
        label: 'دسترسی پشتیبانی',
        minWidth: 100,
        align: 'right',
    },
    {
        id: 'created_at',
        label: 'تاریخ ایجاد',
        minWidth: 100,
        align: 'right',
    },
    {
        id: 'users',
        label: 'اعضا',
        minWidth: 100,
        align: 'center',
    },
    {
        id: 'services',
        label: 'سرویس ها',
        minWidth: 100,
        align: 'center',
    },
    {
        id: 'action',
        label: 'عملیات',
        minWidth: 100,
        align: 'center',
    },
]

export const accessGroupMemberColumns = [
    {id: 'id', label: 'ردیف', width: 50, align: 'right'},
    {id: 'user_mobile', label: 'شماره تلفن', minWidth: 100, align: 'center'},
    {id: 'user_full_name', label: 'نام', minWidth: 100, align: 'center'},
    {id: 'created_at', label: 'تاریخ ایجاد', minWidth: 100, align: 'center'},
    {id: 'action', label: 'عملیات', minWidth: 100, align: 'center'},
]

export const accessGroupServiceColumns = [
    {id: 'id', label: 'ردیف', width: 50, align: 'right'},
    {id: 'service_name', label: 'نام سرویس', minWidth: 100, align: 'center'},
    {id: 'service_id', label: 'شماره سرویس', minWidth: 100, align: 'center'},
    {id: 'created_at', label: 'تاریخ ایجاد', minWidth: 100, align: 'center'},
    {id: 'action', label: 'عملیات', minWidth: 100, align: 'center'},
]

export const numSeperator = (n) => {
    return String(n).replace(/(.)(?=(\d{3})+$)/g, '$1,');
};

export function add(accumulator, a) {
    return accumulator + a;
}

export const removeStorage = () => {
    localStorage.removeItem('product');
    localStorage.removeItem('validList');
    localStorage.removeItem('attrList');
    localStorage.removeItem('sum');
};
